import { render, staticRenderFns } from "./businesstabs.vue?vue&type=template&id=9fea6c18&"
import script from "./businesstabs.vue?vue&type=script&lang=js&"
export * from "./businesstabs.vue?vue&type=script&lang=js&"
import style0 from "./businesstabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fea6c18')) {
      api.createRecord('9fea6c18', component.options)
    } else {
      api.reload('9fea6c18', component.options)
    }
    module.hot.accept("./businesstabs.vue?vue&type=template&id=9fea6c18&", function () {
      api.rerender('9fea6c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/businesstabs.vue"
export default component.exports